import { useState } from 'react';
import { initialsOf } from '../utils/liveLessonText';
import { AVATAR_CROP, avatarInitialsSize } from '../utils/avatar';

/**
 * A person's photo (components.md 4): a circle, object-fit cover, always
 * the face-safe crop favouring the top of the photo (50% 20%), so a 4:5
 * coach portrait never centre-crops to a chest. Without a photo, or when
 * it fails to load, the initials in the label colour on the tertiary fill,
 * semibold at 40% of the diameter. No silhouette. Sizes in use: 16 read
 * receipt, 28 a message run, 36 a thread header, 44 a row, 56 an inbox
 * row, 108 a profile header.
 */
export function Avatar({ url, name, size = 44, className = '' }: { url?: string | null; name: string; size?: number; className?: string }) {
  const [broken, setBroken] = useState<string | null>(null);
  const photo = url && url !== broken ? url : null;
  return (
    <div data-avatar className={`flex flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-[rgba(118,118,128,0.12)] ${className}`}
      style={{ width: size, height: size }}>
      {photo
        ? <img src={photo} alt={name} className="h-full w-full object-cover" style={{ objectPosition: AVATAR_CROP }}
            onError={() => setBroken(photo)} />
        : (
          <span role="img" aria-label={name} className="font-semibold text-db-text-1" style={{ fontSize: avatarInitialsSize(size) }}>
            {initialsOf(name)}
          </span>
        )}
    </div>
  );
}
